import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const dayEnvChecklistDiningSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  diningFloor: environmentalChecklistItemWithTicket,
  diningWindows: environmentalChecklistItemWithTicket,
  diningTable: environmentalChecklistItem,
  diningCurtains: environmentalChecklistItemWithTicket,
  diningDoors: environmentalChecklistItemWithTicket,
  diningHutch: environmentalChecklistItemWithTicket,
  diningComment: z.string().optional(),
});
